import React from 'react'
import { AiOutlineYoutube } from "@react-icons/all-files/ai/AiOutlineYoutube";
import { AiOutlineInstagram } from "@react-icons/all-files/ai/AiOutlineInstagram";
import { SiTiktok } from "@react-icons/all-files/si/SiTiktok";
import logo from '../Assets/SmakonecupLogo.webp'


export default function Footer() {
  return (
    <div className='backdrop-blur-lg bg-gray-900 w-full max-h-auto'>
      {/* laptop view */}
      <div className="hidden md:block pt-5 pb-2 px-8 mx-[50px] pb-[50px]"> 
          <div className='grid grid-cols-2'>
            <div className=''>
              <img src={logo} alt="" className="-ml-16" />
              <div className="text-white font-ProductSans text-left md:text-lg lg:text-xl md:-mt-3">
                Smakonecup Horizon and its logo marks are the property of Smakonecup, a part of SMAK 1 PENABUR Jakarta
              </div>
            </div>
            <div className=''>
              <div className="">
                <h1 className="text-white text-right align-middle md:text-[40px] xl:text-[50px] font-[JakartaSansBold] mt-10">Contact Us</h1>
              </div>
              <div className='flex flex-row-reverse gap-x-1 mt-2'>
                <a href="https://www.instagram.com/smakonecup/" target="_blank" rel="noreferrer">
                  <AiOutlineInstagram color="white" size={45} className="hover:-translate-y-1 duration-300"/>
                </a>
                <a href="https://www.youtube.com/user/SMAK1cup" target="_blank" rel="noreferrer">
                  <AiOutlineYoutube color="white" size={45} className="hover:-translate-y-1 duration-300"/>
                </a>
                <a href="https://www.tiktok.com/@smakonecup" target="_blank" rel="noreferrer">
                  <SiTiktok color="white" size={35} className="hover:-translate-y-1 duration-300"/>
                </a>
              </div>
            </div>
          </div>
          <div className="text-white font-ProductSans text-center md:text-lg lg:text-xl mt-5 md:mt-10">
            Jl. Tanjung Duren Raya No.4, RT.12/RW.2, Tj. Duren Utara, <br className="flex xl:hidden"/>Kec. Grogol petamburan, Kota Jakarta Barat, Daerah Khusus Ibukota Jakarta 11470
          </div>
          <div className='font-ProductSans text-white text-center text-sm md:text-base mb-3'>
            Copyright<sup>&copy;</sup> 2023 Smakonecup Horizon All Rights Reserved
          </div>
      </div>
      {/* mobile view  */}
      <div className="visible md:hidden px-10 pb-2">
        <div className="text-center">
          <img src={logo} alt="" />
        </div>
        <div className="text-white font-ProductSans text-center text-xs -mt-3 mb-2">
          Smakonecup Horizon and its logo marks are the property of Smakonecup, a part of SMAK 1 PENABUR Jakarta
        </div>
        <div className="mb-1 text-center">
          <h1 className="text-white text-2xl font-semibold font-ProductSans">Contact Us</h1>
        </div>
        <div className='flex gap-x-1.5 pb-3 justify-center'>
          <a href="https://www.instagram.com/smakonecup/" target="_blank" rel="noreferrer">
            <AiOutlineInstagram color="white" size={35} className="hover:-translate-y-1 duration-300"/>
          </a>
          <a href="https://www.youtube.com/user/SMAK1cup" target="_blank" rel="noreferrer">
            <AiOutlineYoutube color="white" size={35} className="hover:-translate-y-1 duration-300"/>
          </a>
          <a href="https://www.tiktok.com/@smakonecup" target="_blank" rel="noreferrer">
            <SiTiktok color="white" size={28} className="hover:-translate-y-1 duration-300"/>
          </a>
        </div>
        <div className="text-white font-ProductSans text-center text-xs md:text-sm lg:text-md mt-1 md:mt-2">
          Jl. Tanjung Duren Raya No.4, RT.12/RW.2, Tj. Duren Utara, <br className="flex xl:hidden"/>Kec. Grogol petamburan, Kota Jakarta Barat, Daerah Khusus Ibukota Jakarta 11470
        </div>
        <div className='font-ProductSans text-white text-center text-xs mt-2'>
          Copyright<sup>&copy;</sup> 2023 Smakonecup Horizon<br/>All Rights Reserved
        </div>
    </div>
  </div>
  )
}
